var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 70,
    viewBox: "0 0 105 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 0.000244141H10C4.47715 0.000244141 0 4.47741 0 10.0003V45.2944V60.0002C0 65.5231 4.47716 70.0002 10 70.0002H11.7353H95C100.523 70.0002 105 65.5231 105 60.0002V10.0002C105 4.4774 100.523 0.000244141 95 0.000244141Z",
    fill: "#F1F1FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 0H10C4.47715 0 0 4.47715 0 9.99999V14.2941V19H11.7353H105V10C105 4.47715 100.523 0 95 0Z",
    fill: "#CCCCDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3604 24H61V62.8254H96.3604V24Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_515_9097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 24,
    width: 36,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3604 24H61V62.8254H96.3604V24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_515_9097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.201 34.2761C72.2359 34.4473 69.0757 37.485 68.7319 38.1696C68.3881 38.8542 68.3452 39.6243 68.2592 40.3945C68.1733 41.1646 68.0873 41.9347 67.7006 42.6193C67.056 43.6462 65.6809 44.2024 65.2942 45.3576C64.8644 46.6839 65.9387 48.0531 65.6809 49.4222C65.509 50.1496 64.9934 50.7486 64.8215 51.4759C64.6066 52.2033 64.8215 53.0162 65.2082 53.7008C66.1966 55.3694 68.1733 56.1823 70.107 56.2679C72.0407 56.3535 73.9315 55.7545 75.7363 55.1983",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7358 34.7761C87.4618 35.4607 88.1406 37.7365 88.532 38.2842C88.9624 38.8319 89.5103 39.197 89.98 39.6534C90.4496 40.1097 90.9192 40.703 90.9583 41.4333C90.9975 42.1178 90.7235 42.7568 90.8018 43.4413C90.9975 45.13 93.3456 45.6776 93.463 47.3663C93.5413 48.5072 92.5238 49.5569 92.8368 50.6522C92.9542 51.063 93.2282 51.3824 93.4239 51.7932C94.0892 53.0711 93.6195 54.851 92.6803 55.855C91.7019 56.8591 90.3713 57.2242 89.119 57.2698C88.0232 57.3154 86.81 57.1329 86.1838 56.0832C85.5968 55.1704 82.7142 53.8926 82.8316 52.7516C83.3795 47.4119 84.3012 41.9809 84.1838 36.5956",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3603 53.8032C75.399 51.3695 75.3603 48.8574 75.3603 48.8574C75.3603 48.8574 72.2968 48.3078 71.7152 44.2256C71.1335 40.3395 72.1029 31.9788 72.1029 31.9788C76.5624 30.2124 81.5647 30.8797 84.6669 34.5302L84.2016 54.1565C84.1628 56.4331 82.1464 58.1995 79.7422 58.121C77.2992 58.0425 75.3603 56.1191 75.3603 53.8032Z",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.123 39.1814C74.123 39.4561 74.3169 39.6916 74.6272 39.7309C74.8986 39.7309 75.1313 39.5346 75.17 39.2599C75.17 38.9851 74.9762 38.7496 74.6659 38.7103C74.3945 38.7103 74.1618 38.9066 74.123 39.1814Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3087 38.7891C73.3863 38.8676 73.774 38.5536 74.3169 38.5928C75.3639 38.7498 75.3251 38.9069 75.3251 38.8283C75.3639 38.7891 75.2864 38.6713 75.1313 38.5536C74.9762 38.4358 74.6659 38.2788 74.3169 38.2788C73.9679 38.2788 73.6965 38.3966 73.5026 38.5143C73.3475 38.6321 73.2699 38.7498 73.3087 38.7891Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8223 39.3777C79.8223 39.6525 80.0162 39.888 80.3264 39.9273C80.5978 39.9273 80.8305 39.731 80.8693 39.4562C80.8693 39.1815 80.6754 38.946 80.3652 38.9067C80.0549 38.8674 79.8223 39.103 79.8223 39.3777Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0861 38.9852C79.1636 39.0637 79.5514 38.7497 80.0943 38.7889C80.6372 38.7889 81.0637 39.0637 81.1025 39.0244C81.1413 38.9852 81.0637 38.8674 80.9086 38.7497C80.7535 38.6319 80.4433 38.4749 80.0943 38.4749C79.7453 38.4749 79.4738 38.5927 79.2799 38.7104C79.1248 38.8282 79.0473 38.9459 79.0861 38.9852Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5872 42.9158C77.5767 42.8768 77.2629 42.8992 76.7701 42.9166C76.6354 42.9438 76.5237 42.9253 76.4584 42.8151C76.393 42.7049 76.4182 42.5353 76.4434 42.3657C76.4832 41.9875 76.4893 41.6161 76.5185 41.1989C76.6124 39.576 76.6684 38.2074 76.601 38.221C76.5231 38.1956 76.4228 39.532 76.2953 41.1618C76.266 41.579 76.2599 41.9504 76.2201 42.3286C76.2287 42.4914 76.1803 42.7068 76.3005 42.8881C76.3658 42.9983 76.488 43.0559 76.5554 43.0422C76.6333 43.0676 76.7007 43.054 76.7681 43.0403C77.284 42.9771 77.5872 42.9158 77.5872 42.9158Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3594 48.8181C75.3594 48.8181 78.8958 49.6675 81.5715 48.0974C81.5715 48.0974 79.431 50.2312 75.3982 49.7994L75.3594 48.8181Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6946 44.6223C77.6322 44.581 77.2543 45.0676 76.5946 45.1712C75.9348 45.2747 75.4508 44.8561 75.4046 44.9237C75.3815 44.9576 75.46 45.1078 75.6784 45.2523C75.8967 45.3968 76.2548 45.5357 76.643 45.4979C77.0544 45.4264 77.3871 45.2046 77.5258 45.0017C77.6957 44.8195 77.7257 44.6429 77.6946 44.6223Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7363 31.786C81.2037 34.032 80.8185 34.7952 77.9147 35.2943C78.3796 33.8733 75.1249 36.4507 73.8357 36.8602C72.8001 37.1891 72.3352 37.1891 71.8066 37.2761C71.6049 37.2761 71.3629 37.2761 71.2016 37.1929C70.9596 37.0682 70.9193 36.777 70.879 36.5275C70.758 35.4877 70.6594 33.8089 70.8207 32.7691C70.982 31.7293 71.6452 30.5383 72.4922 29.8312C73.6215 28.9578 75.1944 28.3272 76.727 28.2856C77.9773 28.244 79.3082 28.3272 80.4375 28.7847C81.6071 29.2422 82.575 30.5799 82.7363 31.6613",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0042 40.4544C87.6076 39.4487 87.9711 37.9036 88.0098 37.2363C88.1262 35.156 87.0726 28.6029 79.9375 29.1917L81.2363 31.3898C81.2363 31.3898 78.3559 35.8285 83.1561 38.9656C83.1561 38.9656 82.9817 40.4544 84.5907 42.6667C84.5907 42.6667 85.1941 43.069 87.0042 40.4544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1548 38.966C83.5814 38.8875 84.0467 38.8875 84.4345 39.0838C84.8223 39.2408 85.2101 39.5548 85.3652 39.9474C85.5203 40.3399 85.5203 40.8109 85.3652 41.2427C85.2101 41.6745 84.9386 42.0277 84.6284 42.3418C84.3957 42.5773 84.1631 42.7735 83.8528 42.852C83.5426 42.9305 83.1936 42.8913 82.9609 42.695",
    fill: "#FFBE9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4504 41.9655C83.4126 41.9742 83.6252 42.2074 84.0234 42.0357C84.2037 41.9542 84.3576 41.7578 84.4185 41.5023C84.4881 41.285 84.5111 41.0382 84.4876 40.7617C84.464 40.4852 84.3271 40.2346 84.1611 40.031C83.9661 39.8743 83.7421 39.7646 83.5531 39.8078C83.1751 39.8944 83.0852 40.1968 83.123 40.1882C83.1696 40.2178 83.2857 40.0301 83.5678 40.046C83.8412 40.0237 84.1469 40.3162 84.1764 40.7926C84.235 41.2222 84.1424 41.6863 83.9331 41.8148C83.657 41.9988 83.4795 41.9186 83.4504 41.9655Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3086 75.1647L62.6017 62.6998L69.2715 66.9391L64.6159 75.1647C64.6159 75.1647 63.0865 75.1647 57.3086 75.1647Z",
    fill: "#EB996E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2645 53.8816C69.3667 52.233 75.3608 51.7619 75.3608 51.7619C76.5241 54.1171 80.208 54.4311 82.4183 52.8218L84.2797 51.5264C84.2797 51.5264 84.5511 51.5264 85.0552 51.5657C88.9678 52.61 91.5395 53.5744 92.8253 54.2173C95.0755 56.1461 97.4421 63.734 97.3257 65.4218C97.0931 69.7004 89.7861 69.4256 89.7861 69.4256C89.7861 69.4256 89.6994 71.4101 89.428 74.8251C87.0489 74.8251 87.7697 74.6149 85.443 75.6748C83.7368 76.4598 85.2858 74.8251 79.5716 74.8251C71.2447 74.8251 74.6434 74.8251 69.0355 74.8251C69.6947 70.7428 67.295 69.6611 67.2175 69.4256C67.2175 69.3864 67.2175 69.3471 67.2175 69.3471L62.8744 65.4218L60.3926 63.3415C60.4314 63.3415 63.8215 55.2162 66.2645 53.8816Z",
    fill: "#00A0FF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H18",
    stroke: "#F1F1FE",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6L14 14",
    stroke: "#F1F1FE",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10H96",
    stroke: "#F1F1FE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 31H24",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9 41H54",
    stroke: "#6C6D8A",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M9 57L11 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18 57L20 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M30 57L33 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M47 57L49 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M13 57L16 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M26 57L28 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M41 57L45 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M51 57L54 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M35 57L39 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M22 57L24 57",
    stroke: "#6C6D8A",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceFront);
export default __webpack_public_path__ + "static/media/insuranceFront.500b838b3f216ba5de04eed0d0ab6807.svg";
export { ForwardRef as ReactComponent };